export const assetTypeMap = {
  banner: 'image',
  image: 'image',
  banner_video: 'video',
  video: 'video',
  bundle_adaptive_creative: 'bundle_adaptive_creative',
};

export default {};
